import PopUpMsg from "../Components/PopUpMsg";

function Videos(){
    document.body.style.color = "black";
    return(<PopUpMsg/>)
}
export default Videos;